export { CollapseMenuComponent } from '@shared/layout/header/collapse-menu/collapse-menu.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/collapse-menu/index.ts